<template>
  <div :class="`${rowClass}`">
    <div
      :class="`desktop-width-max-content background-error-50 color-error border-radius-200 font-size-12 font-weight-500 cursor--pointer padding-x-12 padding-y-4 text-center ${buttonClass}`"
      @click="handleOpenDetailModal"
    >
      <span><mdicon name="eye-outline" size="20" /></span>
      <span class="margin-right-8">{{ $lang.viewOnly }}</span>
    </div>
    <Modal
      :show="isDetailModal"
      :title="$lang.viewMessage"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="false"
      @close="handleCloseDetailModal"
    >
      <template #body>
        <div class="font-size-14 color-complementary-300">
          {{ detailMessage }}
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Modal } from "@/components/re-design";
import { computed, ref, toRefs } from "vue";
export default {
  components: { Modal },
  props: {
    rowClass: {
      type: String,
      default: "",
    },
    buttonClass: {
      type: String,
      default: "",
    },
    detailMessage: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const { rowClass, detailMessage } = toRefs(props);

    const isDetailModal = ref(false);
    const handleOpenDetailModal = () => (isDetailModal.value = true);
    const handleCloseDetailModal = () => (isDetailModal.value = false);

    // return data to be used in template
    return {
      rowClass,
      detailMessage,
      isDetailModal,
      handleOpenDetailModal,
      handleCloseDetailModal,
    };
  },
};
</script>
